export function navigateWithFallback(vm, location) {
  const resolved = vm.$router.resolve(location)
  const targetHref = resolved && resolved.href ? resolved.href : ''

  return vm.$router.push(location).catch(() => {
    if (targetHref) {
      window.location.href = targetHref
    }
  }).then(() => {
    if (!targetHref) {
      return
    }
    window.setTimeout(() => {
      const currentHash = window.location.hash || ''
      const targetHash = targetHref.includes('#') ? targetHref.slice(targetHref.indexOf('#')) : targetHref
      if (targetHash && currentHash !== targetHash) {
        window.location.href = targetHref
      }
    }, 120)
  })
}
